@if (entry.base?.display && mustAttest) {
  <!-- Houses dynamically updated stringified data-->
  <form [formGroup]="form" [connect]="'payloadStates.' + entry?.formControlAttributes.connectPath"></form>
  <!-- Houses component specific, parsed data -->
  <h3 class="header big-space">PREMIUM TAX CREDIT ATTESTATIONS</h3>
  <hr/>
  <p>Review the statements below for: </p>
  <p>{{taxFilerNames}}</p>
  <p>I understand that because the premium tax credit will be paid on my behalf to reduce the cost of health coverage for myself and/or my dependents:</p>
  <ul>
    <li>I must file a federal income tax return in <span data-dojo-attach-point='nextYearElement'></span> for the tax year {{effectiveDateYear}}.</li>
    <li>If I'm married at the end of {{effectiveDateYear}}, I must file a joint income tax return with my spouse.</li>
  </ul>
  <p>I also expect that:</p>
  <ul>
    <li>No one else will be able to claim me as a dependent on their {{effectiveDateYear}} federal income tax return.</li>
    <li>I'll claim a personal exemption deduction on my {{effectiveDateYear}} federal income tax return for any individual listed on this application as a dependent who is enrolled in coverage through this Marketplace and whose premium for coverage is paid in whole or in part by advance payments.</li>
  </ul>
  <p>If any of the above changes, I understand that it may impact my ability to get the premium tax credit.</p>
  <p>I also understand that when I file my {{effectiveDateYear}} federal income tax return, the Internal Revenue Service (IRS) will compare the income on my tax return with the income on my application. I understand that if the income on my tax return is lower than the amount of expected household income on my application, I may be eligible to get an additional premium tax credit amount. On the other hand, if the income on my tax return is higher than the amount of income on my application, I may owe additional federal income tax.</p>
  <div [formGroup]="taxFilerForm">
    <!-- Signature 1 (Primary Signature) -->
    <ng-container>
      <mat-form-field class="signature-field">
        <input type="text" matInput formControlName="primaryTaxFiler" placeholder="Type Full Name"/>
        @if (taxFilerFormControls.primaryTaxFiler.errors?.required) {
          <mat-error>This field is required.</mat-error>
        }
        @if (taxFilerFormControls.primaryTaxFiler.errors?.valueExactlyMatchesInput) {
          <mat-error>Type your name as it appears above.</mat-error>
        }
      </mat-form-field>
      <p>Date: {{signOrSubmissionDate}}</p>
    </ng-container>
    <!-- Signature 2 (Joint Filer Signature) -->
    @if (taxFilerFormControls.jointTaxFiler) {
      <mat-form-field class="signature-field">
        <input type="text" matInput formControlName="jointTaxFiler" placeholder="Type Full Name"/>
        @if (taxFilerFormControls.jointTaxFiler.errors?.required) {
          <mat-error>This field is required.</mat-error>
        }
        @if (taxFilerFormControls.jointTaxFiler.errors?.valueExactlyMatchesInput) {
          <mat-error>Type your name as it appears above.</mat-error>
        }
      </mat-form-field>
      <p>Date: {{signOrSubmissionDate}}</p>
    }
    <!-- Attestation Checkbox -->
    <mat-checkbox formControlName="attestation">
      <span>I have read and ACCEPT the Premium Tax Credit Attestations.</span>
    </mat-checkbox>
  </div>
}
